import * as React from 'react';
import { AccountFoundPage } from '../../pages/account-found/AccountFoundPage';
import { History } from 'history';
import { LiveChat } from 'ts/components/LiveChat';
import { FeatureSwitch } from '@origin-digital/features';

interface ForgotUsernameAccountFoundPageProps {
  history: History;
  location: Location;
}

const ForgotUsernameAccountFoundPage: React.FC<ForgotUsernameAccountFoundPageProps> = ({
  history,
  location,
}) => {
  return (
    <>
      <AccountFoundPage history={history} location={location} />
      <FeatureSwitch name="sales-r2d2-forgotusername-livechat">
        <LiveChat />
      </FeatureSwitch>
    </>
  );
};

export { ForgotUsernameAccountFoundPage };
